// import React, { useState } from "react";
// import { Link, Outlet, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FaUser,
//   FaBox,
//   FaMapMarkerAlt,
//   FaWallet,
//   FaHeadset,
//   FaBars,
//   FaTimes,
// } from "react-icons/fa";

// const Account = () => {
//   const user = useSelector((state) => state.user.user);
//   const [open, setOpen] = useState(false);
//   const location = useLocation();

//   const menu = [
//     { name: "My Profile", path: "profile", icon: <FaUser /> },
//     { name: "My Orders", path: "orders", icon: <FaBox /> },
//     { name: "Address", path: "address", icon: <FaMapMarkerAlt /> },
//     { name: "Wallet", path: "wallet", icon: <FaWallet /> },
//     { name: "Help Center", path: "help", icon: <FaHeadset /> },
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200">

//       {/* 🔥 MOBILE HEADER */}
//       <div className="md:hidden flex justify-between items-center p-4 bg-white shadow">
//         <h2 className="font-semibold text-lg">My Account</h2>

//         <button
//           onClick={() => setOpen(true)}
//           className="text-xl"
//         >
//           <FaBars />
//         </button>
//       </div>

//       <div className="max-w-7xl mx-auto flex gap-6 p-4">

//         {/* 🔥 SIDEBAR DESKTOP */}
//         <motion.div
//           initial={{ x: -50, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           className="hidden md:block w-64 bg-white rounded-2xl shadow-lg p-5"
//         >
//           {/* Profile */}
//           <div className="text-center mb-6">
//             <div className="w-16 h-16 mx-auto bg-gradient-to-r from-green-500 to-green-600 text-white flex items-center justify-center rounded-full text-xl font-bold shadow">
//               {user?.name?.charAt(0) || "U"}
//             </div>
//             <h3 className="mt-3 font-semibold">{user?.name}</h3>
//             <p className="text-sm text-gray-500">{user?.email}</p>
//           </div>

//           {/* Menu */}
//           <div className="space-y-2">
//             {menu.map((item) => (
//               <Link
//                 key={item.name}
//                 to={item.path}
//                 className={`flex items-center gap-3 p-3 rounded-lg transition-all ${
//                   location.pathname.includes(item.path)
//                     ? "bg-green-500 text-white shadow"
//                     : "hover:bg-gray-100"
//                 }`}
//               >
//                 {item.icon} {item.name}
//               </Link>
//             ))}

//             {user?.role === "ADMIN" && (
//               <Link
//                 to="/dashboard"
//                 className="block mt-3 text-blue-600 font-medium"
//               >
//                 Admin Panel
//               </Link>
//             )}
//           </div>
//         </motion.div>

//         {/* 🔥 MOBILE SIDEBAR */}
//         <AnimatePresence>
//           {open && (
//             <>
//               {/* Overlay */}
//               <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 0.4 }}
//                 exit={{ opacity: 0 }}
//                 onClick={() => setOpen(false)}
//                 className="fixed inset-0 bg-black z-40"
//               />

//               {/* Sidebar */}
//               <motion.div
//                 initial={{ x: -300 }}
//                 animate={{ x: 0 }}
//                 exit={{ x: -300 }}
//                 className="fixed top-0 left-0 w-64 h-full bg-white z-50 shadow-lg p-5"
//               >
//                 <div className="flex justify-between items-center mb-5">
//                   <h3 className="font-semibold">Menu</h3>
//                   <FaTimes onClick={() => setOpen(false)} className="cursor-pointer" />
//                 </div>

//                 {/* Profile */}
//                 <div className="mb-6">
//                   <h3 className="font-semibold">{user?.name}</h3>
//                   <p className="text-sm text-gray-500">{user?.email}</p>
//                 </div>

//                 {/* Menu */}
//                 <div className="space-y-3">
//                   {menu.map((item) => (
//                     <Link
//                       key={item.name}
//                       to={item.path}
//                       onClick={() => setOpen(false)}
//                       className="block hover:text-green-600"
//                     >
//                       {item.name}
//                     </Link>
//                   ))}
//                 </div>
//               </motion.div>
//             </>
//           )}
//         </AnimatePresence>

//         {/* 🔥 CONTENT */}
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           className="flex-1 bg-white rounded-2xl shadow-lg p-4 md:p-6"
//         >
//           <Outlet />
//         </motion.div>

//       </div>
//     </div>
//   );
// };

// export default Account;
import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaUser,
  FaBox,
  FaMapMarkerAlt,
  FaHeadset,
  FaBars,
  FaTimes,
  FaLaptop,
  FaShieldAlt,
} from "react-icons/fa";

const Account = () => {
  const user = useSelector((state) => state.user.user);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const menu = [
    { name: "Profile", path: "profile", icon: <FaUser /> },
    { name: "Orders", path: "orders", icon: <FaBox /> },
    { name: "My Devices", path: "devices", icon: <FaLaptop /> }, // 🔥 NEW
    { name: "Warranty", path: "warranty", icon: <FaShieldAlt /> }, // 🔥 NEW
    { name: "Address", path: "address", icon: <FaMapMarkerAlt /> },
    { name: "Help", path: "help", icon: <FaHeadset /> },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white">

      {/* 🔥 MOBILE HEADER */}
      <div className="md:hidden flex justify-between items-center p-4">
        <h2 className="font-semibold text-lg">My Account</h2>
        <FaBars onClick={() => setOpen(true)} />
      </div>

      <div className="max-w-7xl mx-auto flex gap-6 p-4">

        {/* 🔥 SIDEBAR DESKTOP */}
        <motion.div
          initial={{ x: -40, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          className="hidden md:flex flex-col w-72 p-5 rounded-3xl backdrop-blur-lg bg-white/10 border border-white/20 shadow-xl"
        >
          {/* Profile Card */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto rounded-full bg-gradient-to-r from-green-400 to-green-600 flex items-center justify-center text-2xl font-bold shadow-lg">
              {user?.name?.charAt(0) || "U"}
            </div>
            <h3 className="mt-4 text-lg font-semibold">{user?.name}</h3>
            <p className="text-sm text-gray-300">{user?.email}</p>

            <div className="mt-3 text-xs bg-green-500/20 px-3 py-1 rounded-full inline-block">
              Verified User
            </div>
          </div>

          {/* Menu */}
          <div className="space-y-2">
            {menu.map((item) => {
              const active = location.pathname.includes(item.path);

              return (
                <Link key={item.name} to={item.path}>
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className={`flex items-center gap-3 p-3 rounded-xl transition-all ${
                      active
                        ? "bg-gradient-to-r from-green-500 to-green-600 text-white shadow-lg"
                        : "hover:bg-white/10"
                    }`}
                  >
                    {item.icon}
                    {item.name}
                  </motion.div>
                </Link>
              );
            })}

            {user?.role === "ADMIN" && (
              <div className="mt-4">
                <Link
                  to="/admin-panel"
                  className="text-blue-400 text-sm hover:underline"
                >
                  Go to Admin Panel →
                </Link>
              </div>
            )}
          </div>
        </motion.div>

        {/* 🔥 MOBILE SIDEBAR */}
        <AnimatePresence>
          {open && (
            <>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.5 }}
                exit={{ opacity: 0 }}
                onClick={() => setOpen(false)}
                className="fixed inset-0 bg-black z-40"
              />

              <motion.div
                initial={{ x: -300 }}
                animate={{ x: 0 }}
                exit={{ x: -300 }}
                className="fixed top-0 left-0 w-72 h-full bg-gray-900 z-50 p-5"
              >
                <div className="flex justify-between mb-6">
                  <h3>Menu</h3>
                  <FaTimes onClick={() => setOpen(false)} />
                </div>

                {menu.map((item) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    onClick={() => setOpen(false)}
                    className="block py-3 border-b border-gray-700"
                  >
                    {item.name}
                  </Link>
                ))}
              </motion.div>
            </>
          )}
        </AnimatePresence>

        {/* 🔥 MAIN CONTENT */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="flex-1 bg-white/10 backdrop-blur-lg border border-white/20 rounded-3xl p-6 shadow-xl"
        >
          {/* 🔥 Top Welcome */}
          <div className="mb-6">
            <h2 className="text-2xl font-bold">
              Welcome back, {user?.name} 👋
            </h2>
            <p className="text-gray-300 text-sm">
              Manage your refurbished laptops, orders & warranty here.
            </p>
          </div>

          <Outlet />
        </motion.div>

      </div>
    </div>
  );
};

export default Account;